import { getStorage, ref, uploadString } from "firebase/storage";
import { app } from "../firebase/firebase";

// 使用数据URI格式的SVG
const userPlaceholderSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">
  <rect width="150" height="150" fill="#f0f0f0"/>
  <circle cx="75" cy="60" r="30" fill="#cccccc"/>
  <circle cx="75" cy="160" r="70" fill="#cccccc"/>
</svg>`;

const productPlaceholderSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
  <rect width="100" height="100" fill="#f0f0f0"/>
  <rect x="25" y="25" width="50" height="50" fill="#cccccc"/>
  <text x="50" y="55" font-size="10" text-anchor="middle" fill="#666666">产品图片</text>
</svg>`;

// 上传用户头像占位图到Firebase Storage
export const uploadUserPlaceholder = async () => {
  try {
    console.log('开始上传用户头像占位图...');
    
    // 转换为数据URI
    const dataUri = `data:image/svg+xml;base64,${btoa(userPlaceholderSvg)}`;

    // 上传到Firebase Storage
    const storage = getStorage(app);
    const placeholderRef = ref(storage, 'placeholders/user-placeholder.png');

    const snapshot = await uploadString(placeholderRef, dataUri, 'data_url');
    
    console.log('成功上传用户头像占位图!', snapshot);
    return `https://storage.googleapis.com/${storage.bucket}/placeholders/user-placeholder.png`;
  } catch (error) {
    console.error('上传占位图失败:', error);
    throw error;
  }
};

// 上传产品图片占位图到Firebase Storage
export const uploadProductPlaceholder = async () => {
  try {
    console.log('开始上传产品图片占位图...');
    
    // 转换为数据URI
    const dataUri = `data:image/svg+xml;base64,${btoa(productPlaceholderSvg)}`;

    // 上传到Firebase Storage
    const storage = getStorage(app);
    const placeholderRef = ref(storage, 'placeholders/product-placeholder.png');

    const snapshot = await uploadString(placeholderRef, dataUri, 'data_url');
    
    console.log('成功上传产品图片占位图!', snapshot);
    return `https://storage.googleapis.com/${storage.bucket}/placeholders/product-placeholder.png`;
  } catch (error) {
    console.error('上传占位图失败:', error);
    throw error;
  }
};

// 执行上传
export const uploadAllPlaceholders = async () => {
  try {
    const userPlaceholderUrl = await uploadUserPlaceholder();
    const productPlaceholderUrl = await uploadProductPlaceholder();
    
    console.log('所有占位图上传成功!');
    console.log('用户头像占位图URL:', userPlaceholderUrl);
    console.log('产品图片占位图URL:', productPlaceholderUrl);
    
    return {
      userPlaceholderUrl,
      productPlaceholderUrl
    };
  } catch (error) {
    console.error('上传占位图失败:', error);
    throw error;
  }
};

// 直接导出数据URI以便在代码中使用
export const USER_PLACEHOLDER_DATA_URI = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='150' viewBox='0 0 150 150'%3E%3Crect width='150' height='150' fill='%23f0f0f0'/%3E%3Ccircle cx='75' cy='60' r='30' fill='%23cccccc'/%3E%3Ccircle cx='75' cy='160' r='70' fill='%23cccccc'/%3E%3C/svg%3E`;

export const PRODUCT_PLACEHOLDER_DATA_URI = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Crect x='25' y='25' width='50' height='50' fill='%23cccccc'/%3E%3Ctext x='50' y='55' font-size='10' text-anchor='middle' fill='%23666666'%3E产品图片%3C/text%3E%3C/svg%3E`;

// Firebase Storage URL (在生产环境使用)
export const USER_PLACEHOLDER_URL = `https://storage.googleapis.com/destinycrystal-ff557.firebasestorage.app/placeholders/user-placeholder.png`;
export const PRODUCT_PLACEHOLDER_URL = `https://storage.googleapis.com/destinycrystal-ff557.firebasestorage.app/placeholders/product-placeholder.png`;